import React from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import StockList from './pages/StockList';
import Price from './pages/Price';
import Login from './pages/Login';
import GoogleCallback from './pages/GoogleCallback';
import { AuthProvider } from './context/AuthContext';
import PhyidList from './pages/PhyidList';
import ProtectedRoute from './components/ProtectedRoute';
import VotePrint from './pages/VotePrint';
import Feature from './pages/Feature';
import Register from './pages/Register';
import GiftList from './pages/GiftList';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/stocklist" element={<StockList />} />
              <Route path="/price" element={<Price />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/auth/google/callback" element={<GoogleCallback />} />
              <Route path="/voteprint" element={<VotePrint />} />
              <Route path="/feature" element={<Feature />} />
              <Route 
                path="/phyidlist" 
                element={
                  <ProtectedRoute>
                    <PhyidList />
                  </ProtectedRoute>
                } 
              />
              <Route
                path="/gifts"
                element={
                  <ProtectedRoute>
                    <GiftList />
                  </ProtectedRoute>
                }
              />
              {/* ... other routes ... */}
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
